import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Swords } from 'lucide-react';
import toast from 'react-hot-toast';

const Battle: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Show a message that we're redirecting to the new battle system
    toast.success('Redirecting to the new Battle Mode!');
    
    // Redirect to the new battle hub after a short delay
    const timer = setTimeout(() => {
      navigate('/battle/hub');
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center h-96">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center justify-center mb-6">
          <div className="bg-accent/20 p-6 rounded-full">
            <Swords className="w-16 h-16 text-accent" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-center mb-2">
          Welcome to Battle Mode
        </h1>
        <p className="text-textMuted text-center mb-6">
          Redirecting you to our new and improved Battle Hub...
        </p>
        <div className="flex justify-center">
          <div className="animate-pulse bg-accent/30 h-1 w-24 rounded-full"></div>
        </div>
      </motion.div>
    </div>
  );
};

export default Battle;